import React, { useReducer, useMemo, useEffect } from 'react';
import cn from 'classnames';
import styles from './WinMessages.scss';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';

import WinMessagesOption from './WinMessages.option';

interface IWinMessagesState {
    clickedLevel: number | null;
}

const WinMessagesLevels: React.FC = () => {
    const winLevels = useMemo(() => ConfigLoader.getConfiguration(EConfigurationNames.GAME)?.winLevels || [], []);

    const [state, setState] = useReducer((s: IWinMessagesState, ns: Partial<IWinMessagesState>) => ({ ...s, ...ns }), {
        clickedLevel: null
    });

    const firstNamedIdx = winLevels.findIndex((l: any) => !!l.name);
    const unnamed = firstNamedIdx === -1 ? winLevels : winLevels.slice(0, firstNamedIdx);
    const named = firstNamedIdx === -1 ? [] : winLevels.slice(firstNamedIdx);

    const winOptionSet = (index: number) => {
        setState({ clickedLevel: index });
    };

    return (
        <div className={styles.winMessages_levels_group}>
            <div className={styles.winMessages_header}>Win Levels</div>

            <div className={styles.winMessages_levels}>
                {unnamed.map((level, i) => (
                    <WinMessagesOption key={i} activeIndex={state.clickedLevel} index={i} level={level} onClick={winOptionSet} />
                ))}

                {named.map((level, j) => {
                    const origIndex = firstNamedIdx + j;
                    return <WinMessagesOption key={origIndex} activeIndex={state.clickedLevel} index={origIndex} level={level} onClick={winOptionSet} />;
                })}
            </div>
        </div>
    );
};

export default WinMessagesLevels;
